var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hidden),expression:"!hidden"}],class:['tab-pane', {'active': _vm.active}, _vm.bodyClass],attrs:{"role":"tabpanel","id":_vm.id}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }